// extracted by mini-css-extract-plugin
module.exports = {"section":"_1oXkD","wrapper":"_2jrLa","iframe":"_1TVrU"};